/**
 * Created by tomers on 6/14/2015.
 */
define(function (require) {
    "use strict";

    var LE = require("app");
    var template = require("user-management-templates/users/usersGridView.tmpl");
    var UsersGridRowView = require("user-management-views/users/UsersGridRowView");
    var UserListFootnoteView = require("user-management-views/users/UserListFootnoteView");
    var UsersGridEmptyView = require("user-management-views/users/UsersGridEmptyView");

    var Loader = require("ui/loader/Loader");

    var UsersGridView = {};

    function moduleDefinition(LEUserManagement, LE, Backbone, Marionette, $, _) {

        UsersGridView = Marionette.GridView.extend({
            className: "table-main ui-table",
            template: template,
            itemViewContainer: "tbody",
            itemView: UsersGridRowView,
            emptyView: UsersGridEmptyView,
            withUIComponents: true,
            ui: {
                footnoteContainer: ".footnote-container",
                footnoteLoaderContainer: ".footnote-loader-container",
                groups: ".groups"
            },
            uiComponents: {
                loader: {
                    type: Loader,
                    options: {
                        el: "view.ui.footnoteLoaderContainer",
                        permutation: Loader.PERMUTATION.H
                    }
                }
            },
            initialize : function (options) {
                LEUserManagement.logger.debug("onRender", "UsersGridView:onRender");
                this.settingsCollection = options.settingsCollection;
                this.listenTo(this.settingsCollection,"fetch:success",this._displayFootNote);
                this.listenTo(this.settingsCollection,"fetch:error",this._displayFootNote);
                this.groupColumnVisible = false; //init to false we accept this in a setter function, so its redundent to get by options
            },

            onRender: function() {
                LEUserManagement.logger.debug("onRender", "UsersGridView:onRender");
                this._displayGroupsColumn();
                this._displayFootNote();
            },

            onCompositeCollectionRendered:function(){
                LEUserManagement.logger.debug("onCompositeCollectionRendered enter", "UsersGridView:onCompositeCollectionRendered");
                _.each(this.collection.getSelected(), function(selectedModel){
                    if (!_.isEmpty(this.children.findByModel(selectedModel))) {
                        selectedModel.trigger("model:selection:change", true);
                    }
                }, this);
                LEUserManagement.logger.debug("onCompositeCollectionRendered exit", "UsersGridView:onCompositeCollectionRendered");
            },


            setGroupsColumnVisibility: function(groupColumnVisible){
                this.groupColumnVisible = groupColumnVisible;
                this._displayGroupsColumn();
                //currently there is no reason to go over the children view and call showGroupsColumn() they are recreated after collection is fetched/move to the groups tab
            },
            onClose: function(){
                LEUserManagement.logger.debug("onClose", "UsersGridView:onClose");
            },
            itemViewOptions: function(model, index) {
                return {
                    groupColumnVisible: this.groupColumnVisible
                };
            },
            _displayGroupsColumn: function () {
                if (this.ui.groups.toggleClass){ //ui was initialized
                    this.ui.groups.toggleClass("hide", !this.groupColumnVisible);
                }

            },
            _displayFootNote: function () {
                if (this.settingsCollection.isLastFetchReturnedSuccess()){
                    LEUserManagement.logger.debug("_onSettingsFetchSuccess", "UsersGridView:_onSettingsFetchSuccess");
                    this._showFootnoteView(true, this.settingsCollection);
                }else{
                    LEUserManagement.logger.debug("_onSettingsFetchError", "UsersGridView:_onSettingsFetchError");
                    this._hideFootnoteView();
                }
            },
            _showFootnoteView: function(footnoteState, settingsCollection) {
                LEUserManagement.logger.debug("showFootnoteView enter", "UsersGridView:showFootnoteView");
                if (this.uiComponents.footnote) {
                    this.uiComponents.footnote.updateSettings(settingsCollection);
                } else{
                    this.uiComponents.host$.createAndRender("footnote", {
                        type: UserListFootnoteView,
                        options:{
                            el: this.ui.footnoteContainer,
                            collection: settingsCollection
                        }
                    });
                }
                if (this.uiComponents.loader) {
                    this.uiComponents.loader.close();
                }
                this.ui.footnoteContainer.removeClass("hide");
                LEUserManagement.logger.debug("showFootnoteView exit", "UsersGridView:showFootnoteView");

            },

            _hideFootnoteView: function() {
                LEUserManagement.logger.debug("hideFootnoteView ", "UsersGridView:hideFootnoteView");
                if (this.uiComponents.loader) {
                    this.uiComponents.loader.close();
                }
                this.ui.footnoteContainer.addClass("hide");
            }


        });

    }

    LE.module("LEUserManagement", moduleDefinition);

    return UsersGridView;
});
